module.exports = __webpack_public_path__ + "static/media/user-img-depoimento-video-04.0782a1ce.jpg";